import moment from "moment-timezone";
import { toast } from 'react-toastify';

const timeZone = "Australia/Sydney";

const checkOrderProcess = (contextValues, page = '') => {
    return new Promise((resolve, reject) => {
        if (page === '') {
            if (contextValues.orderRecieveStatus === 'delivery') {
                const sessionSelectedAddress = JSON.parse(localStorage.getItem("SELECTED_ADDRESS"));
                if (!sessionSelectedAddress) {
                    toast.error('No address found, please add an address');
                    return resolve(false);
                }
            }
            if (contextValues.orderRecieveStatus === 'pickup') {
                if (!contextValues.selectedStore || !(contextValues.selectedStore.store_id > 0)) {
                    toast.error('No pickup store selected');
                    return resolve(false);
                }
            }
        }

        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        const now = moment().tz(timeZone);

        const currentDate = now.format('YYYY-MM-DD');
        const currentTime = now.format('HH:mm:ss');

        const { lunch_end_time, dinner_end_time, pickup_lunch_end_time, pickup_dinner_end_time } = contextValues?.settingData || {};

        let lunchEndTime, dinnerEndTime;
        if (contextValues.orderRecieveStatus === 'delivery') {
            if (!lunch_end_time || !dinner_end_time) {
                toast.error("Lunch and Dinner time not found");
                return resolve(false);
            }
            lunchEndTime = lunch_end_time;
            dinnerEndTime = dinner_end_time;
        } else {
            if (!pickup_lunch_end_time || !pickup_dinner_end_time) {
                toast.error("Lunch and Dinner time not found");
                return resolve(false);
            }
            lunchEndTime = pickup_lunch_end_time;
            dinnerEndTime = pickup_dinner_end_time;
        }

        for (let item of cart) {
            if (item.product_selected_date < currentDate) {
                toast.error(`${item.product_name} is not available, please change the date`);
                return resolve(false);
            }
            
            const selectedDate = moment.tz(item.product_selected_date, 'YYYY-MM-DD', timeZone).format('YYYY-MM-DD');
            if (currentDate === selectedDate) {
                if (item.product_time === 'lunch' && currentTime > lunchEndTime) {
                    toast.error(`${item.product_name} Lunch order time has ended`);
                    return resolve(false);
                } else if (item.product_time === 'dinner' && currentTime > dinnerEndTime) {
                    toast.error(`${item.product_name} Dinner order time has ended`);
                    return resolve(false);
                }
            }
        }
        resolve(true);
    });
};

export { checkOrderProcess };